import { render, staticRenderFns } from "./PermeabilityRecord.vue?vue&type=template&id=07ca8314"
import script from "./PermeabilityRecord.vue?vue&type=script&lang=js"
export * from "./PermeabilityRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports